export default __webpack_public_path__ + "static/Euclid Circular A Bold-b4788f2f8f64a74fe6d6f6a8b7b96c40.ttf";